import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Supplies from './Supplies';
import Toggle from './Toggle';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    head: {
        height: 28
    },
    noBorder: {
        borderBottom: 'none'
    }
});

const Devices = props => (
    <Toggle>{(isExtended, handleExtend) => (
        <Table>
            <TableHead>
                <TableRow className={props.classes.head}>
                    <TableCell>Producer</TableCell>
                    <TableCell>Model</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.data.map(device => {

                    const result = [
                        <TableRow key={device.id}>
                            <TableCell>
                                <IconButton aria-label="Extend" onClick={handleExtend(device.id)}>
                                    {isExtended(device.id) ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
                                </IconButton>
                                {device.manufacturer}
                            </TableCell>
                            <TableCell>{device.model}</TableCell>
                        </TableRow>
                    ];
                    if (isExtended(device.id) && device.supplies.size) {
                        result.push(
                            <TableRow key={`${device.id}-child`}>
                                <TableCell className={props.classes.noBorder} colSpan={99}>
                                    <Supplies data={device.supplies} />
                                </TableCell>
                            </TableRow>
                        )
                    }

                    return result;
                })}
            </TableBody>
        </Table>
    )}
    </Toggle>
);

Devices.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Devices);


// WEBPACK FOOTER //
// ./src/modules/clients/src/components/Devices.js